import { useTranslation } from 'react-i18next';
import { Building2, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '../../hooks/useAuth';

/**
 * Shown when a signed-in user is not confirmed staff of any gym, so there is
 * nothing for them to manage.
 */
export default function NoGyms() {
  const { t } = useTranslation();
  const { signOut } = useAuth();

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 bg-muted/30 p-6 text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-muted">
        <Building2 className="size-7 text-muted-foreground" />
      </div>
      <h1 className="text-lg font-semibold">{t('gymAdmin.noGyms.title')}</h1>
      <p className="max-w-md text-sm text-muted-foreground">{t('gymAdmin.noGyms.description')}</p>
      <Button variant="outline" onClick={signOut}>
        <LogOut className="mr-2 size-4" />
        {t('gymAdmin.signOut')}
      </Button>
    </div>
  );
}
